import { ComponentStyleConfig, cssVar } from '@chakra-ui/react';

const $bg = cssVar('menu-bg');

export const Menu: ComponentStyleConfig = {
  baseStyle: {
    // button: baseStyleButton,
    list: {
      [$bg.variable]: '#fff',
      color: 'inherit',
      minW: '3xs',
      p: '3px',
      zIndex: 1,
      borderRadius: 'lg',
      border: '1px solid',
      borderColor: 'stroke.grey',
      bg: $bg.reference,
      boxShadow: 'md',
    },
    item: {
      py: '1.5',
      px: '3',
      borderRadius: 'md',
      transitionProperty: 'background',
      transitionDuration: 'ultra-fast',
      transitionTimingFunction: 'ease-in',
      fontSize: 'md',
      _hover: {
        [$bg.variable]: 'background.secondary',
      },
      _focus: {
        [$bg.variable]: 'blackAlpha.20',
      },
      _active: {
        [$bg.variable]: 'inherit',
      },
      _expanded: {
        [$bg.variable]: 'blackAlpha.20',
      },
      _disabled: {
        opacity: 1,
        color: 'text.quaternary',
        cursor: 'not-allowed',
      },
      bg: $bg.reference,
    },
    // groupTitle: baseStyleGroupTitle,
    // command: baseStyleCommand,
    divider: {
      my: '3px',
    },
  },
};
